import MessageBox from '@/components/common/messagebox/MessageBox.vue';
import ClientBillAttach from '@/components/client/bills/attach/ClientBillAttach.vue';
import ClientBillEdit from '@/components/client/bills/edit/ClientBillEdit.vue'
import BillsListExpand from '@/components/client/bills/listexpand/BillsListExpand.vue'
import BillsNotify from '@/components/client/bills/notify/BillsNotify.vue'
import { mapState } from 'vuex';

const defaultFilterValues = {
  bill_number: '',
  reportSubCode: [],
  fromDatePeriod: null,
  toDatePeriod: null,
  isPaid: [],
  onlyMine: [],
  managers: [],
  dueDateMissed: [],
  lastNotificationBefore: null
}

export default {
  name: 'ClientBills',
  props: ['loadData', 'data', 'pagingData', 'clientApi'],
  data () {
    return {
      isMounted: false,
      loading: false,
      items: null,
      currentReq: null,
      clientApiId: null,
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'created_at', direction: 'desc' },
      paging: {
        limit: 10,
        total: 0,
        page: 1,
        pages: 1
      }
    }
  },
  components: {
    MessageBox,
    ClientBillAttach,
    ClientBillEdit,
    BillsListExpand,
    BillsNotify
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'created_at', label: this.$t('bill.created'), type: 'datetime', sortable: true },
        { key: 'bill_number', label: this.$t('bill.number'), filterKey: 'bill_number' },
        { key: 'type_id', label: this.$t('bill.type'), format: 'formatFromConfig', configKey: 'bill_types', configParam: 'name', filterKey: 'type', sortable: true },
        { key: 'due_date', label: this.$t('bill.due_date'), type: 'date', sortable: true },
        { key: 'date_period_id', label: this.$t('bill.date_period_id'), format: 'formatDatePeriod', sortable: true },
        { key: 'client_report.summary', label: '', format: 'formatReportModificationIcons', class: 'text-right' },
        {
          key: 'client_report.report_config_id',
          label: this.$t('bill.report'),
          type: 'actionlinks',
          emit: 'viewreport',
          actionFormat: 'formatFromConfig',
          configKey: 'report_configs',
          configParam: 'name'
        },
        { key: 'price_no_pvn', label: this.$t('bill.price_no_pvn'), format: 'formatDecimal', precision: 2 },
        { key: 'price_total', label: this.$t('general.currency'), format: 'formatDecimal', precision: 2 },
        { key: 'remainingBalance', label: this.$t('bill.remainingBalance'), format: 'formatDecimal', precision: 2, filterKey: 'isPaid' }
      ];

      if (this.canViewAll) {
        if (!this.clientApiId) {
          headers.unshift({ key: 'client.balance', label: this.$t('client.balanceAxapta'), format: 'formatDecimal', precision: 2 });
          headers.unshift({ key: 'client.name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'client.api_id' }, filterKey: 'clientName', sortable: true });
        }
        headers.push({ key: 'mails', label: this.$t('bill.mailtimes'), type: 'slot', slotcode: 'notifycount' });
      }
      const actions = [
        { label: this.$t('menu.file.download'), emit: 'downloadBill', bicon: 'download', ifconfig: { param: 'file', value: null, notCheck: true }, class: 'btn-download' }
      ];
      if (this.canEdit) {
        actions.push({ label: this.$t('menu.clientbills.sendBill'), emit: 'mailBill', bicon: 'envelope-fill', ifconfig: { param: 'file', value: null, notCheck: true }, class: 'btn-secondary' })
        actions.push({ label: this.$t('general.actions.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil' });
        actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash' });
      }
      headers.push({ key: 'actions', label: '', actions: actions, class: 'col-width-large' })
      return headers;
    },
    tableExpandConfig () {
      if (this.canViewAll) {
        return { component: 'slot' };
      }
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      filters.bill_number = { type: 'text', label: '', colOnlyFilter: true };
      filters.reportSubCode = { type: 'checkbox', label: this.$t('client.filters.reportSubCode'), options: this.reportNameOptions, colOnlyFilter: false };
      filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), colOnlyFilter: false, class: 'col-md-3' }
      filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), colOnlyFilter: false, class: 'col-md-3' }
      if (this.canViewAll && !this.clientApiId) {
        filters.onlyMine = { type: 'checkbox', label: ' ', options: this.onlyMineOptions, class: 'col-md-2' };
        filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'api_id' };
      }
      filters.clientName = { type: 'text', label: this.$t('client.name'), colOnlyFilter: true }
      if (this.canViewAll) {
        filters.lastNotificationBefore = { type: 'date', label: this.$t('bill.lastNotificationBefore'), colOnlyFilter: false, class: 'col-md-3' }
        filters.dueDateMissed = { type: 'checkbox', options: this.BasicHelper.yesNoOptions(false), label: this.$t('bill.dueDateMissed'), colOnlyFilter: false }
      }
      filters.type = { type: 'checkbox', label: 'billtype', colOnlyFilter: true, options: this.billTypeOptions }
      filters.isPaid = { type: 'checkbox', label: 'isPaid', colOnlyFilter: true, options: this.BasicHelper.yesNoOptions(true) }
      return filters;
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    },
    billTypeOptions () {
      return this.$store.getters.getConfigOptions('bill_types', this.$i18n.locale);
    },
    requestPath () {
      let path = 'client-bill/list';
      if (this.clientApiId) {
        path += '/' + this.clientApiId;
      }
      return path;
    },
    canViewAll () {
      return this.ApiRequest.userHasPermission('view-clients');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    filterActions () {
      const actions = { filters: false, reload: false, download: false, extra: [] };
      if (this.canViewAll) {
        actions.download = true;
      }
      if (this.canEdit && this.clientApiId) {
        actions.add = { title: this.$t('menu.bills.attach') }
      } else if (this.canEdit) {
        actions.extra.push({ title: this.$t('menu.bills.notify'), class: 'btn-secondary', event: 'openBillNotifyFrm', icon: 'envelope-fill' })
      }
      return actions;
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    },
    onlyMineOptions () {
      return [
        { code: 1, text: this.$t('client.onlyMine') }
      ];
    }
  },
  methods: {
    getTableData () {
      this.changePage(this.paging.page);
    },
    getRequestPath (download, pageNr) {
      let path = this.requestPath;
      if (download) {
        path += '?download=1';
      } else {
        path += '?perPage=' + this.paging.limit + '&page=' + pageNr;
      }
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    },
    changePage (pageNr) {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.paging.page = pageNr;
      this.loading = true;
      this.$forceUpdate();
      let filterValues = this.BasicHelper.cloneObject(this.filterValues);
      if (this.$refs.billstable) {
        filterValues = this.$refs.billstable.getFilterValues();
        this.BasicHelper.updateFilterValues(this.$route.name, filterValues);
      }
      const self = this;
      this.currentReq = this.ApiRequest.request(this.getRequestPath(false, pageNr), this.ApiRequest.REQUEST_POST, filterValues, function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging.limit = response.paging.limit;
          self.paging.total = response.paging.total;
          self.paging.page = response.paging.page;
          self.paging.pages = response.paging.pages;
          self.loading = false;
        }
        self.$forceUpdate();
      })
    },
    download () {
      const self = this;
      const path = this.getRequestPath(true, 1);
      let filterValues = this.BasicHelper.cloneObject(this.filterValues);
      if (this.$refs.billstable) {
        filterValues = this.$refs.billstable.getFilterValues()
      }
      this.$refs.billstable.setDownloading(1);
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_DOWNLOAD, filterValues, function () {
        self.$refs.billstable.setDownloading(0);
      })
    },
    downloadBill (el) {
      this.items.find(tmpEl => tmpEl.id === el.id).loading = true;
      this.$refs.billstable.$forceUpdate();
      const self = this;
      this.ApiRequest.request('client-bill/' + el.id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.items.find(tmpEl => tmpEl.id === el.id).loading = false;
        self.$refs.billstable.$forceUpdate();
      });
    },
    mailBill (el, approved = false) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('client-bill/' + el.id + '/mail', this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          }
        });
      } else {
        this.$refs.mailBillApprove.show(el, this.$t('menu.clientbills.sendTitle'), this.$t('menu.clientbills.sendMessage', { number: el.bill_number }))
      }
    },
    viewreport (index, newtab = false) {
      const clientId = (this.items[index].client ? this.items[index].client.api_id : this.clientApiId)
      const clientReport = this.items[index].client_report;
      const reportCode = this.$store.getters.getParamFromConfig('report_configs', clientReport.report_config_id, 'code');
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.report', params: { clientApiId: clientId, reportCode: reportCode, datePeriodCode: clientReport.date_period_id } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + clientId + '/report/' + reportCode + '/' + clientReport.date_period_id);
      }
    },
    updateSort (item, desc) {
      this.tableSorting.item = item;
      if (desc) {
        this.tableSorting.direction = 'DESC';
      } else {
        this.tableSorting.direction = 'ASC';
      }
      this.changePage(this.paging.page);
    },
    openBillAttachFrm () {
      this.$refs.clientBillAttach.show({ client: { api_id: this.clientApiId }, clientReport: null });
    },
    openBillNotifyFrm () {
      this.$refs.clientBillNotify.show(this.filterValues);
    },
    deleteItem (el, approved = false) {
      if (approved) {
        const self = this;
        this.loading = true;
        const apiId = (el.client ? el.client.api_id : this.clientApiId);
        this.ApiRequest.request('client-bill/delete/' + apiId + '/' + el.id, this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
            this.loading = false;
          } else {
            self.getTableData();
          }
        });
      } else {
        this.$refs.deleteBillApprove.show(el, this.$t('menu.clientbills.deleteTitle'), this.$t('menu.clientbills.deleteMessage', { number: el.bill_number }))
      }
    },
    editItem (el) {
      this.$refs.clientBillEdit.show(el, (el.client ? el.client.api_id : this.clientApiId));
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    if (this.$route.path === '/bills/list') {
      this.clientApiId = (this.canViewAll ? '' : this.BasicHelper.getUserClientApiId());
    } else {
      this.clientApiId = this.clientApi;
    }

    if (!this.loadData && this.data) {
      this.items = this.data;
      this.paging = this.pagingData;
    }
    this.isMounted = true;
    if (!(!this.loadData && this.data)) {
      this.getTableData();
    }
  }
}
